import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { mapTo, take } from 'rxjs/operators';
import { CmFeatureService, CmSettingsService } from '../services';

@Injectable()
export class CmFeatureGuard implements CanActivate {
	constructor(private settings: CmSettingsService, private features: CmFeatureService) {}

	canActivate(): Observable<boolean> {
		return this.features.fetchPublicFeatures$(this.settings.client).pipe(take(1), mapTo(true));
	}
}
